<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-goods"></i> 低值易耗申领</span>
      </div>

      <!-- 查询区域 -->
      <el-form
        :model="queryParams"
        label-position="left"
        label-width="70px"
        style="margin-bottom: 20px"
      >
        <el-row :gutter="20" type="flex" align="middle">
          <!-- 关键字 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="申请人">
              <el-input
                v-model="queryParams.name"
                placeholder="请输入申请人"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>

          <!-- 发起时间 -->
          <el-col :xs="24" :sm="24" :md="8" :lg="6">
            <el-form-item label="发起时间">
              <el-date-picker
                v-model="queryParams.applyTimeRange"
                type="daterange"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                clearable
                style="width: 100%"
                @change="handleDateChange"
              />
            </el-form-item>
          </el-col>

        </el-row>

        <!-- 按钮区域 -->
        <div>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
          >
            搜索
          </el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button @click="handleExport">导出</el-button>
        </div>
      </el-form>

      <!-- 表格展示 -->
      <el-table
        :data="tableData"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column
          prop="applyDeptName"
          label="申请部门"
          width="120"
          fixed
        />
        <el-table-column
          prop="applyUserName"
          label="申请人"
          width="120"
          fixed
        />
        <el-table-column
          prop="applyRemark"
          label="申请清单"
          width="180"
          fixed
        />
        <el-table-column prop="assetsName" label="申领物资" width="180" />
        <el-table-column prop="approveUserName" label="审批人" width="120" />
        <el-table-column prop="approveStatus" label="审批状态" width="100">
          <template slot-scope="scope">
            {{ materialStatusMap[Number(scope.row.approveStatus)] }}
          </template>
        </el-table-column>
        <el-table-column prop="approveRemark" label="驳回信息" width="180" />
        <el-table-column prop="deliverName" label="发放人" width="120" />
        <el-table-column prop="deliverStatus" label="发放状态" width="100">
          <template slot-scope="scope">
            {{ Number(scope.row.deliverStatus) === 0 ? "未发放" : "已发放" }}
          </template>
        </el-table-column>
        <el-table-column prop="ccUserNames" label="抄送给" width="150">
          <template slot-scope="scope">
            {{
              scope.row.ccUserNames
                ? scope.row.ccUserNames.replace(/\|/g, ",")
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="发起时间" width="160" />
      </el-table>

      <!-- 分页 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />
    </el-card>
  </div>
</template>

<script>
import { getDeliveLogList, getDeliveLogListExport } from "@/api/admin";
import PaginationBar from "@/components/PaginationBar";
import { downloadFile } from "@/utils/util";

export default {
  name: "ConsumableApplicationList",
  components: { PaginationBar },
  data() {
    return {
      materialStatusArr: [
        { value: 0, label: "待审批" },
        { value: 1, label: "已审批" },
        { value: 2, label: "审批驳回" },
        { value: 3, label: "已取消" },
        { value: 4, label: "待领用" },
        { value: 5, label: "已领用" },
        { value: 6, label: "待发放" },
      ],
      materialStatusMap: {
        0: "待审批",
        1: "已审批",
        2: "审批驳回",
        3: "已取消",
        4: "待领用",
        5: "已领用",
        6: "待发放",
      },
      selectedRows: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      queryParams: {
        name: "",
        applyTimeRange: [],
      },
      tableData: [],
      begin_date: "",
      end_date: "",
    };
  },
  created() {
    this.handleQuery(1);
  },
  methods: {
    mapToSelectOptions(map) {
      return Object.entries(map).map(([value, label]) => ({
        value: Number(value),
        label,
      }));
    },
    handleDateChange(dateRange) {
      if (dateRange && dateRange.length === 2) {
        this.begin_date = dateRange[0]; // "2025-05-30 00:00:00"
        this.end_date = dateRange[1]; // "2025-06-02 23:59:59"
      } else {
        this.begin_date = "";
        this.end_date = "";
      }
    },
    handleQuery(page) {
      // 如果没有参数, 默认第一页
      this.currentPage = page || 1;
      // 接口请求
      getDeliveLogList({
        page_no: this.currentPage,
        page_size: this.pageSize,
        key_word: this.queryParams.name,
        begin_date: this.begin_date,
        end_date: this.end_date,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams = {
        name: "",
        applyTimeRange: [],
      };
      this.handleQuery(1);
    },
    handleExport() {
      const exportData = this.tableData;
      if (exportData.length === 0) {
        this.$message.warning("没有可导出的数据");
        return;
      }

      getDeliveLogListExport({
        page_no: this.currentPage,
        page_size: this.pageSize,
        key_word: this.queryParams.name,
        begin_date: this.begin_date,
        end_date: this.end_date,
      }).then((res) => {
        downloadFile(
          res.data,
          "低值易耗申领列表数据.xlsx",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
      });
    },
  },
};
</script>

<style scoped>
.app-container {
  .el-icon-document {
    margin-right: 5px;
  }
}
.demo-form-inline {
  .el-form-item {
    margin-bottom: 10px;
  }
}
</style>
